import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ShowEveryXQuarters, } from '../../../timing/ShowEveryXQuarters';
import { FeedbackFivePoint, } from './FeedbackFivePoint';
/**
 * # 1-5 feedback form (quarterly)
 * This is a "rate us 1 to 5" feedback component. It shows the
 * user a 1 thru 5 rating scale, where 1 is dissatisfied and 5
 * is satisfied. The user will then be shown input for freeform
 * text feedback. If they complete the form, it displays a thank
 * you message.
 *
 * Dismissing or completing the form will set a local storage value
 * that will prevent the form from showing up again for a certain
 * number of quarters across the entire site. This is to
 * prevent the user from seeing the form multiple times in a single
 * session.
 *
 * This specific instance displays takes a number of quarters
 * `quartersBetweenRequests` and displays itself to the user every
 * that many quarters. EX: `quartersBetweenRequests=2` would ask
 * for feedback every semester.
 */
export const FeedbackFivePointEveryXQuarters = (_a) => {
    var { children } = _a, businessDayProps = __rest(_a, ["children"]);
    return (_jsx(ShowEveryXQuarters, Object.assign({ quartersBetweenRequests: businessDayProps.quartersBetweenRequests, quartersBetweenDismiss: businessDayProps.quartersBetweenDismiss }, { children: ({ setLastSent, setLastDismiss }) => (_jsx(FeedbackFivePoint, Object.assign({ source: businessDayProps.source, onComplete: () => setLastSent(Date.now()), onHide: () => setLastDismiss(Date.now()) }, { children: children }))) })));
};
